module.exports = __webpack_public_path__ + "static/media/homepage_featured.fb8fc556.png";